<template>
  <div class="detail-box">
    <div class="detail-title">
      <div class="detail-title-big">{{$route.meta.title}}</div>
      <div class="detail-title-small">{{$route.meta.title}}</div>
    </div>
    <div class="detail-info">
      <div class="detail-info-title">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(item,index) of humList" :key="index">{{ item.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="detail-info-title-right">
          <el-input v-model="searchQuery.gjc" clearable placeholder="输入关键词，搜项目、公告、规则…" class="input-with-select"></el-input>
          <el-button type="primary" @click="searchList">查询</el-button>
        </div>
      </div>
      <div class="detail-info-content">
        <div class="detail-info-content-list">
          <div class="detail-info-content-table">
            <template>
              <el-table
                header-cell-class-name="table-header-own"
                :data="tableData"
                stripe
                style="width: 100%"
              >
                <el-table-column prop="title" label="标题" show-overflow-tooltip="" min-width="240"></el-table-column>
                <el-table-column align="center" prop="createTime" label="创建时间" min-width="100"></el-table-column>
                <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="viewDetail(scope.row)"
                      type="warning"
                      size="small"
                    >查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <div class="detail-info-content-table-page">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="10"
                layout="total, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {

      tableData: [
        
      ],
      listType: 1,
      currentPage: 1,
      humList: [],
      total:0,
      searchQuery:{
        gjc:''
      }
    }
  },
  watch: {
    $route(to, from) {
      this.humList = to.matched
      // 在路由变化时执行的操作
    this.getList()

    }
  },
  created() {},
  mounted() {
    this.humList = this.$route.matched
    this.getList()
  },
  methods: {
    searchList(){
      this.currentPage = 1 
      this.getList()
    },
    getList(){
      let params = {
        pageNum:this.currentPage,
        category:this.$route.params.category,
        gjc:this.searchQuery.gjc
      }
      this.axios.get('https://admin.jshtcq.com/api/sy/noticeTable',{params}).then(res=>{
        this.tableData = res.data.rows
        this.total=res.data.total
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
            this.currentPage = val
      this.getList()
    },
    changeCurrentPage(index) {
      let path = '/xm/' + index.replaceAll('-', '/')
      this.$router.push({
        path: path
      })
    },
    viewDetail(row){
      this.$router.push({
        path:`/messageDetail/${row.noticeId}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-submenu.is-active .el-submenu__title {
    border-bottom-color: #409eff;
    color: #0c6aec !important;
  }
}
.detail-box {
  background: #f7f7f7;

  .detail-title {
    width: 100%;
    height: 250px;
    background: url('./../assets/jsht/detail/detail_top_bg.png') left top
      no-repeat;
    background-size: 100% 100%;
    position: relative;
    .detail-title-big {
      font-family: YouSheBiaoTiHei;
      font-size: 150px;
      color: rgba(0, 101, 240, 0.12);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 195px;
      line-height: 195px;
      margin-top: 16px;
    }
    .detail-title-small {
      font-family: YouSheBiaoTiHei;
      font-size: 52px;
      color: #0c6aec;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 68px;
      line-height: 68px;
      margin-top: 108px;
    }
  }

  .detail-info {
    padding: 0 240px;

    .detail-info-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 52px;

      .detail-info-title-right {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        .input-with-select{
          width: 300px;
          margin-right: 12px;
        }
      }
    }

    .detail-info-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;


      .detail-info-content-list {
        flex: 1;

        .detail-info-content-list-search {
          background: #ffffff;
          padding: 20px 40px;
          width: 100%;

          .detail-info-content-list-search-item {
            height: 42px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            .detail-info-content-list-search-item-title {
              font-weight: 400;
              font-size: 15px;
              color: #1e1e1e;
            }

            .detail-info-content-list-search-item-tag {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;

              .detail-info-content-list-search-item-tag-detail {
                & + .detail-info-content-list-search-item-tag-detail {
                  margin-left: 20px;
                }

                font-weight: 400;
                font-size: 15px;
                height: 28px;
                line-height: 28px;
                color: #898989;
                padding: 0 14px;
                cursor: pointer;

                &.active {
                  background: rgba(12, 106, 236, 0.1);
                  border-radius: 4px;
                  border: 1px solid #0c6aec;
                  color: #0c6aec;
                }
              }

              .detail-info-content-list-search-item-tag-city {
                margin-left: 34px;
                width: 300px;
              }
            }
          }
        }
      }

      .detail-info-content-table {
        margin-top: 12px;
        margin-bottom: 78px;

        // background: #ffffff !important;
        ::v-deep {
          .table-header-own {
            font-size: 16px !important;
            color: #0c6aec !important;
            background: #ffffff !important;
          }
        }

        .detail-info-content-table-page {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          margin-top: 30px;
        }

      }
    }
  }
}
</style>